import React from 'react'

import { PresetConfigLoader } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Common/PresetConfigLoader'
import { InviteTeamMembers } from '../../../views/Setup/AIFeaturePresets/PresetConfig/Common/InviteTeamMembers'

import { useDocumentTypeEffectiveInputParameters, useTeamMembersFilter } from '../hooks'

import { DocumentTypeInputParametersHierarchyConfigComponentProps } from '../model'

import { TeamMemberPresetConfigFormBody } from './TeamMemberPresetConfigFormBody'

export const DocumentTypeTeamMemberTemplateInputParameterConfigForm: React.FC<DocumentTypeInputParametersHierarchyConfigComponentProps> = ({
  type,
  typeId,
  inputParametersSchema,
  defaultInputParameters,
  documentTypeId,
  showCustomizationSetting,
  onHide,
  ipHierarchyEnabled,
}) => {
  const { userFilterValues, selectedUserFilterOption, setSelectedUserFilterOption, hasTeamMembers, teamMembersLoading } = useTeamMembersFilter()

  const { inputParameters, parentInputParameters, updateLoading, updateInputParameters, isCustomized } = useDocumentTypeEffectiveInputParameters(
    type,
    typeId,
    defaultInputParameters,
    selectedUserFilterOption?.id,
    documentTypeId,
  )

  if (teamMembersLoading || !inputParameters || !parentInputParameters) {
    return <PresetConfigLoader />
  }

  if (!hasTeamMembers) {
    return <InviteTeamMembers />
  }

  return (
    <TeamMemberPresetConfigFormBody
      type={type}
      typeId={typeId}
      inputParametersSchema={inputParametersSchema}
      inputParameters={{ example_1: '', example_2: '', template: inputParameters.template }}
      defaultInputParameters={{ example_1: '', example_2: '', template: defaultInputParameters?.template ?? '' }}
      parentInputParameters={{ example_1: '', example_2: '', template: parentInputParameters.template }}
      isCustomized={isCustomized}
      showCustomizationSetting={showCustomizationSetting}
      onSave={updateInputParameters}
      onHide={onHide}
      updateLoading={updateLoading}
      userFilterValues={userFilterValues}
      selectedUserFilterOption={selectedUserFilterOption}
      setSelectedUserFilterOption={setSelectedUserFilterOption}
      ipHierarchyEnabled={ipHierarchyEnabled}
    />
  )
}
